<div *ngIf="isLoading" class="ui active inverted dimmer">
  <div class="ui text loader">{{loadingMessage}}</div>
</div>

<div class="ui basic segment">

  <button
    class="ui primary right floated button"
    (click)="onSave()"
  >
    Сохранить
  </button>



  <div class="row">
    <label class="inline field"><b>Прикрепленные файлы:</b></label>
    <div class="ui icon buttons right floated">
      <button class="ui button"
              (click)="onFileLoad()"
              suiPopup popupPlacement="top center" popupText="Прикрепить&nbsp;файл">
        <i class="paperclip icon"></i>
      </button>
      <button class="ui button"
              [ngClass]="{'disabled': !filesGrid.state.hasSelection}"
              suiPopup popupPlacement="top center" popupText="Удалить&nbsp;файл"
              (click)="onFileDelete()">
        <i class="trash alternate icon"></i>
      </button>
      <button class="ui button"
              [ngClass]="{'disabled': !filesGrid.state.hasSelection}"
              suiPopup popupPlacement="top center" popupText="Скачать&nbsp;файл"
              (click)="onFileDownload()">
        <i class="download alternate icon"></i>
      </button>
    </div>
  </div>

  <br>
  <div class="row">
    <dx-grid
      #filesGrid
      [options]="filesGridOptions"
      [data]="activityVersion.files"
      (gridReady)="onGridReady()"
      (rowsSelect)="onFilesRowSelect($event)"
      (rowsDeselect)="onFilesRowDeselect($event)">
    </dx-grid>
  </div>


</div>
